
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Personen die eine solche Meldung bekommen dürfen sich laut dem BAG `}<strong parentName="p">{`kostenlos
testen lassen`}</strong>{` können. Sie erhalten eine `}<strong parentName="p">{`Erwerbsausfallentschädigung während
der Quarantäne`}</strong>{`.`}</p>
    <p><strong parentName="p">{`Der Rest der Gesellschaft`}</strong>{` kann weiterhin unter gelockerten Bedingungen
leben.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;